import AbstractBuilder from './builder.js';


export default class ChartBuilder extends AbstractBuilder 
{

	constructor(params) 
	{
		super(params);

		this.chart_class = 'chart_element';
	}


	processServerData(server_data) 
	{
		super.processServerData(server_data);

		if (!this.params.type.length) {
		
			this.params.type = server_data.default_type;
		
		}
	}
	

}